import { render, staticRenderFns } from "./backMessage.vue?vue&type=template&id=77683355&"
import script from "./backMessage.vue?vue&type=script&lang=js&"
export * from "./backMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports